// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1fGmk","footer":"styles_footer__Wxsy3"};